<script setup>
import router from '../../routes/index';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  backUrl: {
    type: [String, Object],
    default: '',
  },
  buttonLabel: {
    type: String,
    default: '',
  },
  compact: {
    type: Boolean,
    default: false,
  },
  iconOnly: {
    type: Boolean,
    default: false,
  },
  iconClass: {
    type: String,
    default: 'text-lg',
  },
});

const { t } = useI18n();

const goBack = () => {
  if (props.backUrl !== '') {
    router.push(props.backUrl);
  } else {
    router.go(-1);
  }
};

const buttonStyleClass = props.compact ? 'text-sm' : 'text-base';
const label = computed(() => props.buttonLabel || t('GENERAL_SETTINGS.BACK'));
</script>

<template>
  <button
    class="flex items-center p-0 font-normal cursor-pointer text-n-slate-11"
    :class="[buttonStyleClass, { 'justify-center': iconOnly }]"
    :aria-label="iconOnly ? label : undefined"
    @click.capture="goBack"
  >
    <i class="i-lucide-chevron-left -ml-1" :class="iconClass" />
    <span v-if="!iconOnly">{{ label }}</span>
  </button>
</template>
